import React from 'react';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { PricePrice } from 'src/types';
import ShippingLabelComponent from '../../../../../../../components/shipping-label';

import * as S from './styles';
import { PriceDisplay } from 'src/areas/product/types';

export const ShippingLabel: React.FC<IShippingLabelProps> = ({
  price,
  priceDisplay,
}) => {
  return (
    <S.ShippingLabelWrapper>
      {price.exclShipping && (
        <BodySmallText>
          <ShippingLabelComponent
            toneDown
            exclShipping={price.exclShipping}
            inclShipping={price.inclShipping}
            priceDisplay={priceDisplay}
          />
        </BodySmallText>
      )}
    </S.ShippingLabelWrapper>
  );
};

interface IShippingLabelProps {
  price: PricePrice;
  priceDisplay: PriceDisplay;
}
